
































import { Component, Mixins } from "vue-property-decorator";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import dateranges from "@/data/dateranges";

@Component({
  components: {
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "tickets-open": () =>
      import("@/components/app/global/stats/ticketsOpen.vue"),
    "tickets-total": () =>
      import("@/components/app/global/stats/ticketsTotal.vue"),
    "chart-tickets": () =>
      import("@/components/app/global/stats/charts/ticketsChart.vue"),
    "chart-provider": () =>
      import("@/components/app/global/stats/charts/chart/chartProvider.vue")
  }
})
export default class TicketsStats extends Mixins(StatsStorageMixin) {
  // Computed
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);
}
